import React, { useEffect, useMemo, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { Constants } from "../../../CommonMethhods/Constants";
import { toast } from "react-toastify";
import Loader from "../../Common/Loader";
import LoaderForSearch from "../../Common/LoaderForSearch";
import { decryptData, noDataFound } from "../../../CommonMethhods/CommonMethods";
import { partner_Admin, partner_Admin_Url } from "../../../Configuration/Partner_URL";
import { useNavigate } from "react-router";
import { useDebounce } from "../../useDebounce";
import { numDifferentiation, numDifferentiationWithoutSymbol } from "../../../CommonMethhods/CovertRupees";
import { axiosSsoFormData, axiosSsoText } from "../../../CommonMethhods/axiosPartnerInterceptor";

function PartnerClientTable() {
  const storeToken = localStorage.getItem("ssoToken");
  const [rangeSelect, setRangeSelect] = useState("till-date");
  const [statsData, setStatsData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState();
  const [scrollLoader, setScrollLoader] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [customDate, setCustomDate] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // useEffect(()=>{
  //   localStorage.removeItem("storePartnerId")
  // },[]);

  const debouncedValue = useDebounce(name, 1000);
  useEffect(() => {
    handleSearchName(debouncedValue);
  }, [debouncedValue]);

  const getTableData = async (pageNo = 1, range) => {
    if (page === 1) {
      setLoader(true);
    }

    try {
      const getValues = await axiosSsoText.get(
        `${partner_Admin.GetClientTable_Url
        }?search=${name}&page=${pageNo}&limit=${10}&range=${range}&to=${toDate}&from=${fromDate}`,
      );
      const tableVal = decryptData(getValues?.data);
      let decryptedTableVal = JSON.parse(tableVal);
      if (decryptedTableVal?.status === 0) {
        setError(false);
        setCount(decryptedTableVal?.data?.total);
        if (pageNo > 1) {
          setStatsData((prev) => {
            return [...prev, ...decryptedTableVal?.data?.partners];
          });
        } else {
          setStatsData(decryptedTableVal?.data?.partners);
        }
      } else if (decryptedTableVal?.status === 1) {
        setStatsData([]);
        // toast.error(decryptedTableVal?.message);
        setError(decryptedTableVal?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
      setScrollLoader(false);
    }
  };

  useEffect(() => {
    if (page > 1 && name.length == 0) {
      getTableData(page, rangeSelect);
    }
  }, [page]);

  const handleScroll = (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (count) {
        if (!(count <= 10 * page)) {
          setPage((prev) => prev + 1);
          setScrollLoader(true);
        }
      }
      if (name?.length > 0) {
        setScrollLoader(false);
      }
    }
  };

  const ascendingOrder = () => {
    let ascendingItems = statsData.sort((a, b) => a.id - b.id);
    setStatsData([...ascendingItems]);
  };

  const descendingOrder = () => {
    let descendingItems = statsData.sort((a, b) => {
      return b.id - a.id;
    });
    setStatsData([...descendingItems]);
  };

  const handleSelect = (e) => {
    setPage(1);
    setStatsData([]);
    setError(false);
    if (e.target.value !== "custom-range") {
      setRangeSelect(e.target.value);
      setName("");
      setFromDate("");
      setToDate("");
    } else {
      setRangeSelect("");
      setName("");
      setCustomDate(true);
    }
    // getTableData(1, e.target.value);


  };
  // search bar start
  const results = useMemo(() => {
    if (name === "") {
      return statsData;
    } else if (statsData && statsData?.length > 0) {
      return statsData?.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(name.toLowerCase())
        )
      );
    }
  }, [name, statsData]);

  // const handleSearch = (e) => {
  //   setError(false);
  //   if (e?.key === "Enter" || e?.key === "Backspace") {
  //     setSearchBar(e?.target?.value);
  //   } else if (e.type === "click") {
  //     const doc = document.getElementById("map-broke")?.value;
  //     setSearchBar(doc);
  //   }
  // };

  const handleName = (data) => {
    if (data?.name !== "") {
      navigate("/partner-details-dashboard");
      localStorage.setItem("storePartnerId", data?.partnerCode);
    }
  };

  const handleSearchName = () => {
    setPage(1);
    if (name?.length > 0 && page === 1) {
      getTableData(1, rangeSelect);
      setLoader(true);
      setScrollLoader(false);
    }

    setScrollLoader(false);
  };

  useEffect(() => {
    if (name === "") {
      getTableData(1, rangeSelect);
    }
  }, [name, rangeSelect]);

  // search bar end

  // const downloadFile = async(url)=>{
  //   const response = await axios.get(url, {
  //     headers: {
  //       // "Content-Type": "text/plain",
  //           Authorization: `Bearer ${storeToken}`,
  //     }

  //   })
  //   const headers = response.headers
  //   if(headers["content-type"] !== "text/csv"){
  //     toast.error("No Data Found")
  //     return
  //   }
  //   const binary = [];
  //   binary.push(response.data)
  //   const href = window.URL.createObjectURL(new Blob(binary, {type: "text/csv"}))
  //   const link = document.createElement("a")
  //   link.href = href
  //   link.setAttribute("download", "lead.csv")
  //   document.body.appendChild(link)
  //   link.click();

  //   document.body.removeChild(link)
  //   window.URL.revokeObjectURL(href);
  // }
const downloadFile = async (url) => {
  const response = await axiosSsoFormData.get(url);

  const headers = response.headers;
  if (headers["content-type"] !== "text/csv") {
    toast.error("No Data Found");
    return;
  }

  // ✅ Generate today's date as YYYY_MM_DD
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  const formattedDate = `${yyyy}_${mm}_${dd}`;

  // ✅ Build dynamic filename
  const filename = `PARTNER_STATS_${formattedDate}.csv`;

  const binary = [];
  binary.push(response.data);
  const href = window.URL.createObjectURL(new Blob(binary, { type: "text/csv" }));
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();

  // Cleanup
  document.body.removeChild(link);
  window.URL.revokeObjectURL(href);
};

  function SubmitButton() {
    if (fromDate && toDate) {
      return (
        <button
          type="button"
          className="rej-btn "
          onClick={() => {
            getTableData(1, rangeSelect);
            setCustomDate(false);
          }}
        >
          Submit
        </button>
      );
    } else {
      return (
        <button type="button" className="rej-btn" disabled>
          Submit
        </button>
      );
    }
  }

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  return (
    <>
      <div className="card-box partnerclient-table onboarding-pending">
        <div className="partnerclient-table-top">
          <div class="search-box">
            <div class="form-group">
              <div class="for-position oms-search partner-search">
                <input
                  type="text"
                  class="input-st"
                  placeholder="Search here..."
                  autocomplete="off"
                  id="map-broke"
                  value={name}
                  // onKeyUp={handleSearch}
                  onChange={(e) => {
                    setName(e?.target?.value);
                    setPage(1);
                  }}
                  onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                />
                {/* <span class="icon-search-bar"></span> */}
              </div>
            </div>
          </div>
          <div className="wrap-download">
            <div
              onClick={() => downloadFile(`${partner_Admin_Url}/admin/partners/csv?search=${name}&page=${1}&limit=${count}&range=${rangeSelect}&to=${toDate}&from=${fromDate}`)}
              className={
                results && results.length > 0
                  ? ""
                  : "disabled-link"
              }
            >
              {/* <img src={download} alt="download" /> */}
              <span className="icon-download"></span>
            </div>
            <Form.Select
              size="lg"
              aria-label="Default select example"
              onChange={handleSelect}
            >
              <option value="till-date">Till Date</option>
              <option value="this-month">Monthly</option>
              {/* <option value="today">Today</option> */}
              <option value="yesterday">Yesterday</option>
              <option value="this-week">Weekly</option>
              {/* <option value="last-week">Last Week</option>
            <option value="last-month">Last Month</option> */}
              {/* <option value="custom-range">Custom Range</option> */}
            </Form.Select>
          </div>
        </div>
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : results && results?.length > 0 ? (
          <div className="scroll-table">
            <table className="table partner-table">
              <thead>
                <tr>
                  <th>
                    <span className="invoice-th">
                      <span>Sr No</span>
                      {/* <span>
                    <span className="icon-up-triangle" onClick={() => descendingOrder()}></span>
                    <span className="icon-down-triangle" onClick={() => ascendingOrder()}></span>
                  </span> */}
                    </span>
                  </th>
                  <th>
                    <span className="invoice-th">
                      <span>Name</span>
                      <span>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder()}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder()}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className="invoice-th">
                      <span>Leads</span>
                      <span>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder()}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder()}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className="invoice-th">
                      <span>Accounts Opened</span>
                      <span>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder()}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder()}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className="invoice-th">
                      <span>Paid Accounts Opened</span>
                      <span>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder()}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder()}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className="invoice-th">
                      <span>Clients Traded</span>
                      <span>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder()}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder()}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className="invoice-th">
                      <span>Commission</span>
                      <span>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder()}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder()}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className="invoice-th">
                      <span>Brokerage</span>
                      <span>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder()}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder()}
                        ></span>
                      </span>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody onScroll={(e) => handleScroll(e)}>
                {results &&
                  results.map((data, index) => {
                    console.log(data, "dataTable");
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        {/* <td>{data?.id || "0"}</td> */}
                        {data?.name != null ? (
                          <td className="cursor" onClick={() => handleName(data)}>
                            {data?.name || "-"}
                          </td>
                        ) : (
                          <td>-</td>
                        )}
                        {/* <td className="cursor" onClick={() => handleName(data)}>
                        {data?.name || "-"}
                      </td> */}
                        <td>{data?.leads || "0"}</td>
                        <td>{data?.accountsOpened || "0"}</td>
                        <td>{data?.paidAccounts || "0"}</td>
                        <td>{data?.clientTraded || "0"}</td>
                        <td>{numDifferentiation(data?.commission) || "0"}</td>
                        <td>{numDifferentiation(data?.brokerage) || "0"}</td>
                      </tr>
                    );
                  })}
                {scrollLoader && (
                  <div className="loader-center">
                    <LoaderForSearch />
                  </div>
                )}
              </tbody>
            </table>
          </div>
        ) : error ? (
          <h4 className="report-error-message">{noDataFound(error)}</h4>
        ) : (
          ""
        )}
        {/* <div>
        <button onClick={() => ascendingOrder()}>ascendingOrder</button>
        <button onClick={() => descendingOrder()}>descendingOrder</button>
      
      </div> */}
      </div>
      {customDate && customDate ? (
        <Modal
          show={customDate}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="setting-model partner-modal-rejection"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              <h2 className="model-title">Custom Date</h2>
            </Modal.Title>
            <button type="button" className="btn-close" aria-label="Close">
              <span
                className="icon-close"
                onClick={() => setCustomDate(false)}
              ></span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="custom-modal-wrapper row">
              <div className="col-md-6  col-sm-12">
                <label className="form-label">{Constants.From_Date}</label>
                <input
                  type="date"
                  placeholder="DD/MM/YYYY"
                  className="form-input"
                  onChange={(e) => setFromDate(e?.target?.value)}
                  max={DateReverse}
                />
              </div>
              <div className="col-md-6  col-sm-12">
                <label className="form-label">{Constants.To_Date}</label>
                <input
                  type="date"
                  placeholder="DD/MM/YYYY"
                  className="form-input"
                  onChange={(e) => setToDate(e?.target?.value)}
                  max={DateReverse}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <SubmitButton />
          </Modal.Footer>
        </Modal>
      ) : null}
    </>
  );
}

export default PartnerClientTable;
